/**
 * Dispara o download de uma URL no navegador via um <a> temporário.
 *
 * Por que não `window.open` nem `<a download>` cru: para URLs presigned do S3
 * (cross-origin) o atributo HTML `download` é IGNORADO pelo navegador (regra de
 * segurança) — então `<a download href={s3url}>` apenas NAVEGA a aba atual pro
 * domínio do S3. O que força o download é o header `Content-Disposition:
 * attachment` que o backend agora assina na URL (`?disposition=attachment`).
 * Com esse header, basta um clique programático num <a> que o navegador baixa
 * sem navegar nem abrir aba em branco.
 *
 * `nome` serve a URL de MESMA origem servida `inline` — a imagem do chat, pelo
 * proxy `/api/v1/storage/file`: ali é o atributo `download` que faz o navegador
 * baixar em vez de abrir, e que dá o nome ao arquivo. Sem `nome`, nada muda.
 */
export function triggerBrowserDownload(url: string, nome?: string): void {
  const a = document.createElement("a");
  a.href = url;
  a.rel = "noopener";
  if (nome) a.download = nome;
  // sem `target=_blank`: evita aba em branco residual; o Content-Disposition:
  // attachment (assinado na URL) garante que o navegador baixe em vez de navegar.
  document.body.appendChild(a);
  a.click();
  a.remove();
}
